<nav class="navbar navbar-expand-lg bg-white shadow-sm py-3 w-100 px-0 px-md-4">
  <div class="container-fluid align-items-center justify-content-between">
    <a class="navbar-brand d-flex align-items-center" routerLink="/app/dashboard">
      <img src="assets/images/vida-optima-logo.svg" alt="Vida Óptima" height="60" class="me-2" />
    </a>
    <div class="navbar-nav d-none d-lg-flex flex-row gap-4 position-absolute start-50 translate-middle-x">
      @if (hasRole(AppRole.CONSULTAR_BALANCE_AHORROS)) {
      <a class="nav-link" routerLink="/app/dashboard" routerLinkActive="active">Inicio</a>
      }
      @if (hasRole(AppRole.REALIZAR_APORTE_EXTRAORDINARIO)) {
      <a class="nav-link" routerLink="/app/realizar-aporte" routerLinkActive="active">Aportar ahora</a>
      }
      @if (hasRole(AppRole.SIMULAR_OBJETIVO_AHORRO)) {
      <a class="nav-link" routerLink="/app/calcular-objetivo-ahorro" routerLinkActive="active">Simulador</a>
      }
      @if (hasRole(AppRole.DEFINIR_OBJETIVO_AHORRO)) {
      <a class="nav-link" routerLink="/app/crear-objetivo" routerLinkActive="active">Nuevo objetivo</a>
      }
      @if (hasRole(AppRole.CONSULTAR_MOVIMIENTOS_OBJETIVO_AHORRO)) {
      <a class="nav-link" routerLinkActive="active">Mis movimientos</a>
      }
    </div>
    <div class="d-flex align-items-center gap-3">
      <div class="user-profile d-flex align-items-center gap-2 cursor-pointer" (click)="toggleMenu()">
        <div class="user-avatar">
          <img src="assets/icons/user-primary-300.svg" />
          @if (notificationCount > 0) {
          <span class="user-avatar__notification-count">{{ notificationCount }}</span>
          }
        </div>
        @if(userName){
        <span class="user-name fs-7 text-neutrals-800 fw-medium ms-2">Hola, {{ userName }}</span>
        }
      </div>
      <div class="menu-icon" (click)="toggleMenu()">
        <img src="assets/icons/message-text.svg" />
      </div>
    </div>
  </div>
</nav>
<div class="dropdown-menu-custom" [class.show]="isMenuOpen">
  <div class="dropdown-item-custom" (click)="closeMenu('notificaciones')">
    <img src="assets/icons/notification.svg" />
    <span>Notificaciones</span>
    @if (notificationCount > 0) {
    <span class="badge-count">{{ notificationCount }}</span>
    }
  </div>
  @if (hasRole(AppRole.CONSULTAR_ESTADO_CUENTA)) {
  <div class="dropdown-item-custom" (click)="closeMenu('consultar-estado-cuenta')">
    <img src="assets/icons/notification.svg" />
    <span>Consultar Estado de Cuenta</span>
  </div>
  }
  @if (hasRole(AppRole.CONFIGURAR_PERFIL)) {
  <div class="dropdown-item-custom" (click)="closeMenu('perfil-usuario')">
    <img src="assets/icons/user.svg" />
    <span>Configurar Datos Personales</span>
  </div>
  }
  @if (hasAnyRole([AppRole.CREAR_METODO_PAGO, AppRole.CONSULTAR_METODO_PAGO, AppRole.MODIFICAR_METODO_PAGO])) {
  <div class="dropdown-item-custom" (click)="closeMenu('metodo-pago')">
    <img src="assets/icons/wallet.svg" style="width: 20px;" />
    <span style="margin-left: 3px;">Configurar Metodos de Pago</span>
  </div>
  }
  @if (hasRole(AppRole.CAMBIAR_CLAVE)) {
  <div class="dropdown-item-custom" (click)="closeMenu('cambiar-password')">
    <img src="assets/icons/security-safe.svg" />
    <span>Cambia tu contraseña, PIN y más</span>
  </div>
  }
  <div class="dropdown-item-custom" (click)="closeMenu('preguntas-frecuentes')">
    <img src="assets/icons/message-add.svg" />
    <span>Preguntas frecuentes</span>
  </div>
  <div class="dropdown-item-custom border-top" (click)="onCloseSession()">
    <img src="assets/icons/logout.svg" />
    <span>Cerrar sesión</span>
  </div>
</div>
<div class="backdrop" [class.show]="isMenuOpen" (click)="closeMenu(null)"></div>